import { css } from 'aphrodite';
import { styleSheet } from '../style';

interface IProps {
	message: string;
}

export const ErrorMessage = ({ message }: IProps) => <p className={css(styleSheet.errorMessage)}>{message}</p>;
